import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { IRequestParams } from './dto/requestDto';

/**
 * Подключение партнерского сервиса
 * @param {IRequestParams} params - параметры запроса
 *
 * {@link https://master.api-vas.sandbox.d2c.r-one.io/docs/#/Vas/VasController_activation Documentation}
 */
export const activation = (params: IRequestParams): IRequest => ({
    uri: '/api/v1/vas/activation',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(params),
});
